import { integerFormatter, numberFormatter, shortDateFormatter } from "../../gridFormatters";

export const hostIopsLatency = [
    {
        "field": "collection_date",
        "headerName": "Collection Date",
        "enableRowGroup": true,
        "filter": "agDateColumnFilter",
        "filterParams": {
            "cellHeight": 20,
            "debounceMs": 1000
        },
        "cellRenderer": shortDateFormatter
    },
    {
        "field": "latency",
        "headerName": "Latency",
        "type": "numericColumn",
        "suppressColumnsToolPanel": true,
        "enableRowGroup": true,
        "filter": "agNumberColumnFilter",
        "filterParams": {
            "cellHeight": 20,
            "debounceMs": 1000
        },
        "cellRenderer": numberFormatter
    },
    {
        "field": "average_latency",
        "headerName": "Avg. Latency",
        "type": "numericColumn",
        "enableRowGroup": true,
        "filter": "agNumberColumnFilter",
        "filterParams": {
            "cellHeight": 20,
            "debounceMs": 1000
        },
        "cellRenderer": numberFormatter
    },
    {
        "field": "compressed_latency",
        "headerName": "Compressed Latency",
        "type": "numericColumn",
        "enableRowGroup": true,
        "filter": "agNumberColumnFilter",
        "filterParams": {
            "cellHeight": 20,
            "debounceMs": 1000
        },
        "cellRenderer": numberFormatter
    },
    {
        "field": "iosec",
        "headerName": "IO/Sec",
        "type": "numericColumn",
        "enableRowGroup": true,
        "filter": "agNumberColumnFilter",
        "filterParams": {
            "cellHeight": 20,
            "debounceMs": 1000
        },
        "cellRenderer": numberFormatter
    },
    {
        "field": "compressed_iops",
        "headerName": "Compressed IOPS",
        "type": "numericColumn",
        "enableRowGroup": true,
        "filter": "agNumberColumnFilter",
        "filterParams": {
            "cellHeight": 20,
            "debounceMs": 1000
        },
        "cellRenderer": numberFormatter
    },
    {
        "field": "mbsec",
        "headerName": "MB per Second",
        "type": "numericColumn",
        "enableRowGroup": true,
        "filter": "agNumberColumnFilter",
        "filterParams": {
            "cellHeight": 20,
            "debounceMs": 1000
        },
        "cellRenderer": integerFormatter
    }
];